export default () => ({
  isShowingLabels: true,
  activeListId: 0,
});
